import { Container, Image } from "@mantine/core";
import LogoFull from "../../../Assets/Images/Svg/LogoFull.svg";
import Forbidden from "../../../Assets/Images/Svg/Forbidden.svg";
import { useStyles } from "./styles";

const ErrorForbidden = () => {
  const { classes } = useStyles();

  return (
    <Container className={classes.container}>
      <Image src={LogoFull} width={400} />
      <Image src={Forbidden} width={500} />
    </Container>
  );
};

export default ErrorForbidden;
